export default __webpack_public_path__ + "static/media/logo-samad.4b197a3c.jpg";